function isPage(className) {
  return document.body.classList.contains(className) || document.body.classList.contains(`page-template-template-${className}`);
}

export {
  isPage
};


// WEBPACK FOOTER //
// ./src/js/vanilla/utils.js